import React, { useState } from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { Product } from '../../../data/models/product_list_response';
import { formatAmount, getImageUrl } from '../../../utility/common';
import { ImageComponent } from '../common/image_component';
import { ProductAddButton } from './product_add_button';
import { ProductVariantAddButton } from './product_variant_add_button';

export const CartProductTile = (props: { product: Product; isEditDisabled?: boolean }) => {
  const { storeSlug } = useParams<any>();
  const [isEdit, setIsEdit] = useState(false);

  if (props.product.haveVariants) {
    return (
      <>
        {props.product.productVariants.map((v) => (
          <div className="flex-col" key={v.id}>
            {/* First Row */}
            <div className="flex flex-row md:flex bg-white rounded-xl pt-6 pb-3">
              <Link to={`/${storeSlug}/product/${props.product?.storeProductId}`} className="w-14 h-14">
                <div className="w-14 h-14">
                  <ImageComponent
                    src={getImageUrl(v.variantPictures)}
                    htmlClass="w-14 h-14 rounded-lg"
                    htmlAlt={v.variantName}
                  />
                </div>
              </Link>

              <div className="w-2/3 md:w-2/3 pl-3 pr-5 text-left">
                <div className="text-black line-clamp-2">{props.product.productName} | {v.variantName}</div>
                <p className="text-inter">
                  <span className="font-semibold">{formatAmount(v.sellingPrice)}</span>
                  <span className="font-normal">/{props.product.productUnit.productUnitName}</span>
                </p>
              </div>
              <div
                className="w-1/3 md:w-full text-right space-y-1"
                // onClick={() => (props.isEditDisabled !== true ? setIsEdit(true) : console.log('edit disabled'))}
              >
                {isEdit ? (
                  props.product.haveVariants ? (
                    <ProductVariantAddButton product={props.product} variantId={props.product.storeProductId} />
                  ) : (
                    <ProductAddButton product={props.product} />
                  )
                ) : (
                  <p className="text-blue-600 font-semibold">{`${v.cartQuantity} ${props.product.productUnit.productUnitName}`}</p>
                )}
              </div>
            </div>
          </div>
        ))}
      </>
    );
  } else {
    return (
      <div className="flex-col">
        {/* First Row */}
        <div className="flex flex-row md:flex bg-white rounded-xl pt-6 pb-3">
          <Link to={`/${storeSlug}/product/${props.product?.storeProductId}`} className="w-14 h-14">
            <div className="w-14 h-14">
              <ImageComponent
                src={getImageUrl(props.product.productPictures)}
                htmlClass="w-14 h-14 rounded-lg"
                htmlAlt={props.product.productName}
              />
            </div>
          </Link>

          <div className="w-2/3 md:w-2/3 pl-3 pr-5 text-left">
            <div className="text-black line-clamp-2">{props.product.productName}</div>
            <p className="text-inter">
              <span className="font-semibold">{formatAmount(props.product.sellingPrice)}</span>
              <span className="font-normal">/{props.product.productUnit.productUnitName}</span>
            </p>
          </div>
          <div
            className="w-1/3 md:w-full text-right space-y-1"
            // onClick={() => (props.isEditDisabled !== true ? setIsEdit(true) : console.log('edit disabled'))}
          >
            {isEdit ? (
              props.product.haveVariants ? (
                <ProductVariantAddButton product={props.product} variantId={props.product.storeProductId} />
              ) : (
                <ProductAddButton product={props.product} />
              )
            ) : (
              <p className="text-blue-600 font-semibold">{`${props.product.cartQuantity} ${props.product.productUnit.productUnitName}`}</p>
            )}
          </div>
        </div>
      </div>
    );
  }
};
